import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { CONTACT, SOCIALS } from "../../data/content";

const SOCIAL_LINKS = [
  { key: "facebook", icon: Facebook, label: "Facebook", url: SOCIALS.facebook },
  { key: "instagram", icon: Instagram, label: "Instagram", url: SOCIALS.instagram },
  { key: "linkedin", icon: Linkedin, label: "LinkedIn", url: SOCIALS.linkedin },
];

export const Footer = () => {
  const socials = SOCIAL_LINKS.filter((s) => s.url);

  return (
    <footer data-testid="footer" className="bg-black border-t border-[#262626] py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="mb-4">
            <img
              src="/logo-jan-dark.png"
              alt="JAN — Servicio y Mantenimiento Minero"
              className="h-28 w-auto"
            />
          </div>
          <p className="font-body text-sm text-neutral-400 leading-relaxed max-w-xs">
            {CONTACT.companyFull}. Mantenimiento y servicio minero de calidad.
          </p>

          {socials.length > 0 && (
            <div className="flex items-center gap-3 mt-5">
              {socials.map((s) => (
                <a
                  key={s.key}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`social-${s.key}`}
                  className="grid place-items-center w-9 h-9 border border-[#262626] text-neutral-400 hover:text-[#FF1616] hover:border-[#FF1616] transition-colors"
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <h4 className="font-heading font-bold uppercase text-white tracking-wide mb-4">Servicios</h4>
          <ul className="space-y-2 font-body text-sm text-neutral-400">
            <li>Motores Deutz</li>
            <li>Motores Cummins</li>
            <li>Motores Mercedes Benz</li>
            <li>Asientos para equipos</li>
            <li>Venta de refacciones</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold uppercase text-white tracking-wide mb-4">Contacto</h4>
          <ul className="space-y-3 font-body text-sm text-neutral-400">
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#FF1616]" /> {CONTACT.phone}
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#FF1616]" /> {CONTACT.email}
            </li>
            <li className="flex items-center gap-2">
              <MapPin size={16} className="text-[#FF1616]" /> {CONTACT.address}
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-[#262626]">
        <p className="font-body text-xs text-neutral-500 text-center">
          © {new Date().getFullYear()} {CONTACT.companyFull}. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};
